module.exports = __webpack_public_path__ + "static/images/idCardExample-1.58ce3d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCardExample-1.png
// module id = RZZz
// module chunks = 0